import { NavLink } from "react-router-dom";
import styled from "styled-components";

const links = [
  { to: "/customer", label: "Tableau de bord" },
  { to: "/customer/profile", label: "Mon profil" },
  { to: "/customer/player-identifiers", label: "Comptes joueurs" },
  { to: "/customer/loyalty", label: "Fidélité" },
  { to: "/customer/events", label: "Événements" },
  { to: "/customer/history", label: "Historique" },
];

export default function CustomerNavigation() {
  return (
    <NavPanel>
      <Title>Mon espace</Title>
      <NavList>
        {links.map((link) => (
          <NavItem key={link.to} to={link.to} end={link.to === "/customer"}>
            {link.label}
          </NavItem>
        ))}
      </NavList>
    </NavPanel>
  );
}

const NavPanel = styled.aside`
  position: sticky;
  top: 1.5rem;
  align-self: start;
  padding: 1rem;
  border-radius: 22px;
  background: #1d263d;
  border: 1px solid rgba(255, 255, 255, 0.08);

  @media (max-width: 900px) {
    position: static;
  }
`;

const Title = styled.h2`
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 950;
`;

const NavList = styled.nav`
  display: grid;
  gap: 0.45rem;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

const NavItem = styled(NavLink)`
  display: block;
  padding: 0.75rem 0.85rem;
  border-radius: 14px;
  color: #fff9ea;
  text-decoration: none;
  font-weight: 850;
  background: rgba(255, 249, 234, 0.06);

  &.active {
    background: #fff9ea;
    color: #0b1328;
  }
`;
